import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const ArrowLeft = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.70703 16.707C9.5195 16.8945 9.26519 16.9998 9.00003 16.9998C8.73487 16.9998 8.48056 16.8945 8.29303 16.707L2.29303 10.707C2.10556 10.5195 2.00024 10.2652 2.00024 10C2.00024 9.73488 2.10556 9.48057 2.29303 9.29304L8.29303 3.29304C8.48163 3.11088 8.73423 3.01009 8.99643 3.01237C9.25863 3.01465 9.50944 3.11981 9.69485 3.30522C9.88026 3.49063 9.98543 3.74144 9.9877 4.00364C9.98998 4.26584 9.88919 4.51844 9.70703 4.70704L5.41403 9.00004H17C17.2652 9.00004 17.5196 9.1054 17.7071 9.29293C17.8947 9.48047 18 9.73482 18 10C18 10.2653 17.8947 10.5196 17.7071 10.7071C17.5196 10.8947 17.2652 11 17 11H5.41403L9.70703 15.293C9.8945 15.4806 9.99982 15.7349 9.99982 16C9.99982 16.2652 9.8945 16.5195 9.70703 16.707Z'
      />
    </svg>
  );
};
